import React from "react";
import { Box, Typography } from "@mui/material";

export default function SidebarBrand() {
    return (
        <Box sx={{ px: 0.25 }}>
            <Box
                component="img"
                src="/pbr-logo.png"
                alt="Point Blank Robotics"
                sx={{
                    display: "block",
                    width: "100%",
                    height: "auto",
                    maxHeight: 52,
                    objectFit: "contain",
                    objectPosition: "left center",
                }}
            />
            <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, mt: 1 }}>
                <Box sx={{ width: 6, height: 6, borderRadius: "50%", bgcolor: "primary.main", boxShadow: "0 0 10px currentColor" }} />
                <Typography variant="caption" color="text.secondary" sx={{ letterSpacing: ".1em", fontWeight: 700 }}>
                    INTERNAL PORTAL
                </Typography>
            </Box>
        </Box>
    );
}
